export default {
    invalidNameFieldMessage: "Please enter a valid name",
    invalidEmailFieldMessage: "Please enter a valid email ",
    updateProfilePictureTitle: "Upload a new profile picture",
    updateProfilePictureSupportedFileText: "JPG, PNG. Max size 2MB",
    updateProfilePictureActionLabel: "Choose file",
    personalInfoFormTitle: "Personal information",
    fullNameFieldLabel: "Full name",
    fullNameFieldPlaceholder: "Enter your name",
    emailFieldLabel: "Email",
    passwordFieldLabel: "Password",
    emailFieldPlaceholder: "Enter your email",
    preferredExamFieldLabel: "Preferred Exam",
    targetScoreFieldLabel: "Target Score",
    termsAndConditionsFieldLabel: "I agree to the Terms of Service and Privacy Policy",
    termsAndConditionsNotAgreedMessage: "Please agree to terms and conditions",
    invalidPasswordFieldMessage: "Please enter a valid password",
    invalidConfirmPasswordMessage: "Passwords do not match",
    passwordFieldPlaceholder: "Create a password",
    currentPasswordFieldPlaceholder: "Enter your password",
    oldPasswordFieldLabel: "Old password",
    oldPasswordFieldPlaceholder: "Enter old password",
    newPasswordFieldLabel: "New Password",
    newPasswordFieldPlaceholder: "Enter new Password",
    confirmPasswordFieldLabel: "Confirm Password",
    confirmPasswordFieldPlaceholder: "Confirm your password",
    confirmNewPasswordFieldPlaceholder: "Confirm new password",
    updatePasswordFieldLabel: "Update password",
    preferredExamFieldDescription: "Which test are your preparing for ?",
    targetScoreFieldDescription: "What grade do you want to achieve ?",

    invalidPhoneFieldMessage: "Please enter a valid phone number",
    selectProviderFieldPrompt: "Please select a provider",
    providerFieldHelperText:"Select provider",
    passwordFieldHelperText:"At least 6 characters long",
    phoneNumberFieldLabel: "Phone",
    providerFieldLabel: "Provider",
}